export default __webpack_public_path__ + "9198876516548c1cbb0d7bb054d76c37.svg";